import { useMedia } from 'react-use';

import { breakpoints } from '../../../../styles/util';
import { ScoreTooltip } from '../../../TokenProfile/TokenLiquidityScore/ScoreTooltip';
import { LiquidityScoreInline } from './LiquidityScoreInline';

export function UnifiedLiquidityScoreCell({ score }: { score: number | undefined }) {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <ScoreTooltip isMobile={isMobile} currentScore={score} zoraType={undefined}>
      <LiquidityScoreInline score={score} isLoading={false} />
    </ScoreTooltip>
  );
}
